export enum EButtonId {
  HEADER = "HEADER",
  HERO = "HERO",
  SUMMARY = "SUMMARY",
  ESSENCE = "ESSENCE",
  TOKEN = "TOKEN",
}
